const togglePrimaryNavSubMenus = () => {
    const headerNav = document.getElementById('header-navs');
    if (!headerNav) return;
    
    const parentItems = headerNav.querySelectorAll('.menu-item-has-children > a');
    if (!parentItems.length) return;

    parentItems.forEach(link => link.setAttribute('aria-expanded', 'false'));

    parentItems.forEach(parentItem => {
        parentItem.addEventListener('click', function(event) {
            event.preventDefault();
            const isOpen = this.nextElementSibling.style.display === 'block';

            // If a top level item, then close all submenus
            if (event.target.closest('ul').id === 'menu-primary-nav') {
              headerNav.querySelectorAll('.menu-item-has-children > a').forEach(link => {
                link.setAttribute('aria-expanded', 'false');
              });
              headerNav.querySelectorAll('.menu-item-has-children > ul').forEach(menu => {
                menu.style.display = 'none';
              });
            }

            // Open this one if it wasn't already open
            if (!isOpen) {
                this.nextElementSibling.style.display = 'block';
                this.setAttribute('aria-expanded', 'true');
            } else {
                this.nextElementSibling.style.display = 'none';
                this.setAttribute('aria-expanded', 'false');
            }
        });
    });
};

const init = () => {
    togglePrimaryNavSubMenus();
};

export default {
    init
};